module.exports = __webpack_public_path__ + "files/4f87f930e15ee5d4aeb88128373d9c19.png";